// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"487":"e6620dcb","990":"4c86ca26"}[chunkId] + ".chunk.js";
};